import 'es6-promise';
import * as React from 'react';
import * as _ from 'lodash';

import * as Actions from './actions';
import * as Rx from 'rx';
import * as redux from 'redux';
import { Provider } from 'react-redux';
import { Store, createStore, applyMiddleware } from 'redux';

import { reduce } from './directory-reducer';
import { render } from 'react-dom';

import { IDirectoryState, IMember, defaultDirectoryModel } from './classes';
import DirectoryListing from './directory-listing';
import DirectoryContainer from './directory-container';

interface IDirectoryProps
{
  baseModel: IDirectoryState<IMember>;
  pageSize: number;
  updatedList: Array<any>;
}

class DirectoryDisplay extends React.Component<IDirectoryProps, any>{

  constructor(props)
  {
    super(props);
  }

  calculateResultsCount()
  {
    var resultsCount = this.props.updatedList.length;
    var endPageCount = this.props.pageSize + this.props.baseModel.currentPage * this.props.pageSize;


    if (resultsCount > 0){
      return `${this.props.baseModel.currentPage * this.props.pageSize + 1} -${endPageCount > resultsCount ? resultsCount : endPageCount}`;
    } else {
      return '0';
    }
  }

  render()
  {

    return (
      <main className="affiliate-listings-container" id="directory-container">
        <aside className="affiliate-search-results">
          <span>Showing <span className="affiliate-results-showing">
            {this.calculateResultsCount()}</span> of <span className="affiliate-results-total">{this.props.updatedList.length}</span> affiliates.</span>
        </aside>

        {(this.props.updatedList.length > 0) ?
          (
            this.props.updatedList.slice(this.props.baseModel.currentPage * this.props.pageSize, (this.props.pageSize + this.props.baseModel.currentPage * this.props.pageSize)).map((member, index) =>
              <DirectoryListing
                key={index}
                name={member.name}
                phone={member.phone}
                primaryCategory={member.primaryCategory}
                email={member.email}
                companyName={member.companyName}
                companyAddress1={member.addressLine1}
                companyAddress2={member.addressLine2}
                companyCity={member.city}
                companyState={member.state}
                companyZipCode={member.zipCode}
                companyWebsite={member.websiteUrl}
                bio={member.biography}
                thumbnail={member.thumbnailUrl}
              />)
          ):
          (
            <section className="no-results-messaging">
              <h2>Sorry, no affiliates were found matching these filters.</h2> 
            </section>
          )
          
        }

        

 
      </main>
    )
  }
}


//{
//(this.state.affiliateCount > 10) && (
//  <AffiliateDirectoryPagination currentPage={this.state.currentPage} affiliateCount={this.state.affiliateCount} resultsPerPage={this.state.resultsPerPage} />
//)
//}

export default DirectoryDisplay;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/directory-display.tsx